export enum CreditGrantTypeEnum {
  PURCHASE = 'PURCHASE',
  GRANT = 'GRANT'
}
